import { BackButton } from "@publicPortal/components/BackButton/BackButton";
import { Grid } from "@mui/material";
import Board from "@publicPortal/components/board/Board";
import ResponsiveAppBar from "@publicPortal/components/responsiveAppBar/ResponsiveAppBar";
import EnforcementAppealsService from "@publicPortal/services/EnforcementAppealsService";
import { IEnforcementAppealDetails } from "@shared/publicportal/contracts/IEnforcementAppealDetails";
import { memo, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Field from "@mirage/components/regularField/Field";

const EnforcementAppeal = memo(() => {
    const service = new EnforcementAppealsService();
    const [appeal, setAppeal] = useState<IEnforcementAppealDetails | null>(null);
    const [loading, setLoading] = useState(true);
    const { id } = useParams();

    useEffect(() => {
        const getAppeal = async () => {
            setLoading(true);
            if (!id || isNaN(Number(id))) {
                setLoading(false);
                setAppeal(null);
            } else {
                const appeal: IEnforcementAppealDetails = await service.getEnforcementAppealById(Number(id));
                setLoading(false);
                setAppeal(appeal);
            }
        };

        getAppeal();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    if ((!appeal || !appeal.id) && !loading) {
        return (
            <>
                <ResponsiveAppBar />
                <Board headerText="Enforcement Appeal not found" loadingHeaderText={loading} size="big">
                    <BackButton />
                </Board>
            </>
        );
    }

    return (
        <>
            <ResponsiveAppBar />
            <Board headerText={"Enforcement Appeal " + (appeal?.name || "(none)")} size="big" loadingHeaderText={loading}>
                <BackButton />
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 6, lg: 6, xl: 6 }}>
                        <Grid>
                            <Field label="Appeal Name" mode="view" value={appeal?.name} contentType="TEXT" hideOnEmpty />
                        </Grid>
                        <Grid>
                            <Field label="Appeal Level" mode="view" value={appeal?.appealLevel} contentType="TEXT" hideOnEmpty />
                        </Grid>
                        <Grid>
                            <Field label="Appellant type" mode="view" value={appeal?.apellantType} contentType="TEXT" hideOnEmpty />
                        </Grid>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6, lg: 6, xl: 6 }} className="grid-nextItem">
                        <Grid>
                            <Field label="Date Started" mode="view" value={appeal?.dateStarted} contentType="DATE" hideOnEmpty />
                        </Grid>
                        <Grid>
                            <Field label="Decision" mode="view" value={appeal?.decisionType?.name} contentType="TEXT" hideOnEmpty />
                        </Grid>
                        <Grid>
                            <Field label="Appeal Decision Date" mode="view" value={appeal?.appealDecisionDate} contentType="DATE" hideOnEmpty />
                        </Grid>
                    </Grid>
                </Grid>
            </Board>
        </>
    );
});

export default EnforcementAppeal;
